// Lazy route-level components (plan 21).
//
// The hash router in `./router.tsx` still drives navigation; this module
// just enumerates the top-level route components as `React.lazy` wrappers
// so each feature ships as its own JS chunk.
//
// Vite treats each `import('../features/…')` below as a split point and
// records the resolved chunk under that source path in `dist/.vite/manifest.json`,
// which `prefetch.ts` then reads to issue `<link rel="prefetch">` hints.

import { lazy } from 'react';

export const LandingPage = lazy(() =>
  import('../features/landing/LandingPage').then((m) => ({ default: m.LandingPage }))
);

export const AboutSection = lazy(() =>
  import('../features/landing/AboutSection').then((m) => ({ default: m.AboutSection }))
);

export const LearnMore = lazy(() =>
  import('../features/landing/LearnMore').then((m) => ({ default: m.LearnMore }))
);

export const ContactPage = lazy(() =>
  import('../features/contact/ContactPage').then((m) => ({ default: m.ContactPage }))
);

export const TermsAndConditions = lazy(() =>
  import('../features/terms/TermsAndConditions').then((m) => ({ default: m.TermsAndConditions }))
);

export const TestimonialSubmissionPage = lazy(() =>
  import('../features/testimonials/TestimonialSubmissionPage').then((m) => ({
    default: m.TestimonialSubmissionPage,
  }))
);

export const ContributionPage = lazy(() =>
  import('../features/contributions/ContributionPage').then((m) => ({
    default: m.ContributionPage,
  }))
);

export const GiftCertificatePage = lazy(() =>
  import('../features/gift-certificates/GiftCertificatePage').then((m) => ({
    default: m.GiftCertificatePage,
  }))
);

export const NetworkPage = lazy(() =>
  import('../features/network/NetworkPage').then((m) => ({ default: m.NetworkPage }))
);

// Migration 063 — public per-product detail page (`#services/<slug>`).
export const ServiceDetailPage = lazy(() =>
  import('../features/services/ServiceDetailPage').then((m) => ({ default: m.ServiceDetailPage }))
);

export const DashboardPage = lazy(() =>
  import('../features/dashboard/DashboardPage').then((m) => ({ default: m.DashboardPage }))
);

export const AdminDashboardPage = lazy(() =>
  import('../features/admin/AdminDashboardPage').then((m) => ({ default: m.AdminDashboardPage }))
);
